module.exports = __webpack_public_path__ + "static/media/android-icon-144x144.49e0ee73.png";